module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue4.f5949e4e.jpg";